module.exports = __webpack_public_path__ + "img/4.ef02c982.jpg";